"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DefaultPathLengths_1 = __importDefault(require("../../../../data/constants/DefaultPathLengths"));
function isDefaultPathLength(pathLength, experimentType) {
    return (DefaultPathLengths_1.default[experimentType] &&
        pathLength.from === DefaultPathLengths_1.default[experimentType].from &&
        pathLength.to === DefaultPathLengths_1.default[experimentType].to);
}
exports.default = isDefaultPathLength;
